module.exports = __webpack_public_path__ + "static/img/jiaJu.70246289.jpg";